import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, Grow, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { useHistory } from "react-router-dom";
import { commonSort } from "../../common";
import AddButton from "../../components/AddButton/AddButton";
import TableButtons from "../../components/Button/TableButtons";
import LoadingBackdrop from "../LoadingBackdrop/LoadingBackdrop";
import Modal from "../Modal/Modal";
import { useTranslation } from "react-i18next";
import { getAllList, updateRecord, deleteRecord, addRecord, getPlants, getMailGroups, getMailPeriods } from "../../store/actions/GeneralTableActions";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";
import SearchBar from "../../components/SearchBar/SearchBar";

export default function GeneralTable(props) {
    const { t } = useTranslation("translation");

    const dispatch = useDispatch();
    const [initialRows, setInitialRows] = useState([]);
    let [rows, setRows] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);

    const { isTaskUpdated, allRecords, plants, mailGroups, mailPeriods } = useSelector(({ generalTable }) => generalTable);

    const [pickDate, setpickDate] = useState(false);
    const [pickEndDate, setpickEndDate] = useState(false);

    useEffect(() => {
        getPlantCodeHandler();
        getMailGroupHandler();
        getMailPeriodsHandler();
        loadHandler();
    }, []);

    useEffect(() => {
        if (allRecords?.resultObject) {
            setPageLoaded(true);
            setRows(Object.values(allRecords.resultObject));
            setInitialRows(cloneObject(Object.values(allRecords.resultObject)));
            setEditableRow(false);
            setDisableButton(false);
        }
    }, [allRecords]);

    useEffect(() => {
        if (plants?.resultObject) {
            setPlantList(plants.resultObject);
        }
    }, [plants]);

    useEffect(() => {
        if (mailGroups?.resultObject) {
            setMailGroupList(mailGroups.resultObject);
        }
    }, [mailGroups]);

    useEffect(() => {
        if (mailPeriods?.resultObject) {
            setMailPeriodList(mailPeriods.resultObject);
        }
    }, [mailPeriods]);

    useEffect(() => {
        if (isTaskUpdated) {
            loadHandler();
        }
    }, [isTaskUpdated]);



    const loadHandler = () => {
        dispatch(getAllList({ table: props.table, resourcePath: props.resourcePath }));
    };

    //get plant codes
    const [plantList, setPlantList] = useState([]);
    const getPlantCodeHandler = () => {
        dispatch(getPlants());
    };

    //get mail groups
    const [mailGroupList, setMailGroupList] = useState([]);
    const getMailGroupHandler = () => {
        dispatch(getMailGroups());
    };

    //expand row
    const [openRow, setOpenRow] = useState(false);
    const [expandID, setExpandId] = useState("");
    const expandRow = (rowId) => {
        if (openRow && expandID !== rowId) {
            setExpandId(rowId);
        } else {
            setOpenRow(!openRow);
            setExpandId(rowId);
        }
    };

    //set plantID
    let [addPlantID, setAddedPlantID] = useState(0);
    let [addPlantName, setAddedPlantName] = useState("");
    const newPlantID = (plantCode) => {
        if (plantCode != null) {
            const filteredPlant = plantList.filter((item) => item.code.includes(plantCode));
            setAddedPlantID(filteredPlant[0].id);
            setAddedPlantName(filteredPlant[0].name);
            return [filteredPlant[0].id, filteredPlant[0].name];
        } else {
            setAddedPlantID(0);
            setAddedPlantName("");
        }
    };

    let [addMailGroupID, setAddedMailGroupID] = useState(null);
    let [addMailGroupName, setAddedMailGroupName] = useState(null);
    const newMailGroupName = (mailGroup) => {
        if (mailGroup != null) {
            const filteredMailGroupName = mailGroupList.filter((item) => item.name.includes(mailGroup));
            setAddedMailGroupID(filteredMailGroupName[0].id);
            setAddedMailGroupName(filteredMailGroupName[0].name);
            return [filteredMailGroupName[0].id, filteredMailGroupName[0].name];
        } else {
            setAddedMailGroupID(null);
            setAddedMailGroupName(null);
        }
    };

    // Mail Group Period
    const [mailPeriodList, setMailPeriodList] = useState([{ code: 0, description: "" }]);

    const getMailPeriodsHandler = () => {
        dispatch(getMailPeriods());
    };

    let [mailPeriodId, setMailPeriodId] = useState(null);
    const newMailPeriod = (mailPeriod) => {
        if (mailPeriod != null) {
            const filteredMailPeriod = mailPeriodList.filter((item) => item.description.includes(mailPeriod));
            setMailPeriodId(filteredMailPeriod[0].code);
            return [filteredMailPeriod[0].code, filteredMailPeriod[0].description];
        } else {
            setMailPeriodId(null);
        }
    };

    //update and add in one function
    const updateAddHandler = (row) => {
        //update
        if (row.id !== "") {
            let data = {
                    id: row.id,
                    code: row.code,
                    name: row.name,
                    breakdownRootCauseLocalizationName: row.breakdownRootCauseLocalizationName,
                    plantId: row.plantId,
                    mailGroupId: addMailGroupID,
                    mailGroupName: addMailGroupName,
                    mailPeriodId: mailPeriodId,
                    status: 1,
            };
            dispatch(updateRecord({ table: props.table, data }));
        }
        //add
        else {
            //enable add button
            let data =  {
                code: row.code,
                name: row.name,
                plantId: addPlantID,
                breakdownRootCauseLocalizationName: row.breakdownRootCauseLocalizationName,
            };

            dispatch(addRecord({ table: props.table, data }));
        }
    };

    //delete
    const deleteHandler = (row) => {
        toggleModal();
        let data = {
                id: row.id,
                code: row.code,
                name: row.name,
                plantId: row.plantId,
                breakdownRootCauseLocalizationName: row.breakdownRootCauseLocalizationName,
            };
        dispatch(deleteRecord({ table: props.table, data }));
    };

    //add blank row for new plant addition
    const addBlankRowHandler = () => {
        setAddedPlantName("");
        setCode("");
        setName("");
        setPage(0);
        setpickDate(true);
        setpickEndDate(true);
        //disable add button
        setDisableButton(true);
        let addedBlankRow = [
            {
                id: "",
                code: "",
                name: "",
                breakdownRootCauseLocalizationName: "",
                plantCode: "",
                plantName: "",
            },
        ];
        rows = addedBlankRow.concat(rows);
        setEditableRow(addedBlankRow[0].id);
        setEditable(true);
        setRows(rows);
    };

    //filter table
    const [filterText, setFilterText] = useState("");
    const searchText = (value) => {
        value = value.toLowerCase();
        setRows(cloneObject(initialRows).filter((item) => item.name?.toLowerCase().includes(value) || item.code?.toLowerCase().includes(value)));

        setDisableButton(false);
    };

    //pagination
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const handleChangePage = (_event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    //edit rows
    const [editable, setEditable] = useState(false);
    const [editableRow, setEditableRow] = useState("");
    const enableEditHandler = (row) => {
        setDisableButton(true);

        if (editable || disableButton) {
            searchText(filterText);
        }
        setCode(row.code);
        setName(row.name);
        setAddedPlantName(row.plantName);
        setpickDate(true);
        setpickEndDate(true);
        setEditableRow(row.id);
        setEditable(true);
    };

    const disableEditHandler = () => {
        searchText(filterText);
        setEditable(false);
        //enable edit button
        setDisableButton(false);
    };

    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    //set edited rows
    const setRowHandler = (value, obj, updatedRow) => {
        const index = rows.indexOf(updatedRow);
        if (updatedRow.id != "") {
            const row = rows[index];
            row[obj] = value;
            rows[index] = row;
            setRows(rows);
        } else {
            const row = rows[index];
            row[obj] = value;
            setRows(rows);
        }
        if (obj === "code") {
            setCode(value);
        }
        if (obj === "name") {
            setName(value);
        }
    };

    const cloneObject = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    const deleteButtonHandler = (row) => {
        setDeletedRow(row);
        toggleModal();
    };

    const toggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    //enable disable add button
    const [disableButton, setDisableButton] = useState(false);

    //dynamic sort function
    let [sortOrder, setSortOrder] = useState();
    let [sortColumn, setSortColumn] = useState();
    const handleSort = (row, column) => {
        const sortedList = commonSort(row, column);
        setSortOrder(sortedList[0]);
        setSortColumn(sortedList[1]);
        setInitialRows(sortedList[2]);
        setRows(sortedList[2]);
    };

    //page redirect
    let history = useHistory();
    const openDetailPage = (id) => {
        if (props.table == "Pool") {
            history.push("/addrelationtopool?id=" + id);
        } 
    };

    const renderTableCell = (rowItems, isSortingAction = true) => {
        var directionType = sortOrder === 1 ? "asc" : "desc";
        return rowItems.map((item, index) => {
            if (item.id === "Actions") {
                return (
                    <TableCell id={`gt_rowItems_TableCell_Actions_${index}_${item.id}`} align="center">
                        {t("Actions")}
                    </TableCell>
                );
            } else {
                return isSortingAction ? (
                    <TableCell id={`gt_rowItems_TableCell_${index}_${item.id}`} align="center">
                        <TableSortLabel
                            id={`gt_rowItems_TableSortLabel_${index}_${item.id}`}
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() => handleSort(cloneObject(initialRows), item.id)}
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

    useEffect(() => {
        searchText(filterText);
    }, [initialRows]);

    // Validation
    const [error, setError] = useState({
        codeText: t("EmptyCheck"),
        nameText: t("EmptyCheck"),
        plantCodeText: t("EmptyCheck"),
    });

    const [isButtonDisable, setIsButtonDisable] = useState(true);

    useEffect(() => {
        const newCodeText = code !== "" ? "" : t("EmptyCheck");
        const newNameText = name !== "" ? "" : t("EmptyCheck");
        const newPlantCodeText = addPlantName !== "" ? "" : t("EmptyCheck");
        setError({
            codeText: newCodeText,
            nameText: newNameText,
            plantCodeText: newPlantCodeText,
        });
    }, [code, name, addPlantName]);

    useEffect(() => {
        if (error.codeText === "" && error.nameText === "" && error.plantCodeText === "") {
            setIsButtonDisable(false);
        } else {
            setIsButtonDisable(true);
        }
    }, [error]);
    return (
        <StyledTableDiv>
            <h1>
                {props.title} {t("List")}{" "}
            </h1>
            <AddButton onClick={() => addBlankRowHandler()} disabled={disableButton} />
            {pageLoaded === true ? (
                <React.Fragment>
                    <Grid container spacing={4} alignItems="center" justifyContent="center" sx={{ marginBottom: 4 }}>
                        <Grid item xs={12} sm={12} md={4}>
                            <SearchBar value={filterText} onChange={(newValue) => setFilterText(newValue)} onRequestSearch={(value) => searchText(value)} />
                        </Grid>
                    </Grid>
                </React.Fragment>
            ) : null}
            <Box m={2} />
            {rows.length > 0 ? (
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                    <TableContainer id="gt_TableContainer" component={Paper}>
                        <Table id="gt_Table" aria-label="simple table">
                            <TableHead id="gt_TableHead">
                                <TableRow id="gt_TableRow">
                                    {renderTableCell([
                                        { id: "id", label: t("ID") },
                                        { id: "code", label: t("Code") },
                                        { id: "name", label: t("Name") },
                                        { id: "breakdownRootCauseLocalizationName", label: t("BreakdownRootCauseLocalized") },
                                        { id: "plantCode", label: t("PlantCode") },
                                        { id: "plantName", label: t("PlantName") },
                                        { id: "Actions", label: t("Actions") },
                                    ])}
                                </TableRow>
                            </TableHead>
                            <TableBody id="gt_TableBody">
                                {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                    <TableRow id={`gt_TableRow_${index}`} key={row.id}>
                                        <TableCell id={`gt_TableCell_${index}`} align="center">
                                            {row.id}
                                        </TableCell>
                                        <TableCell id={`gt_TableCell_1_${index}`} align="center">
                                            {editable && editableRow === row.id ? (
                                                <TextField
                                                    id={`gt_TableCell_1_TextField_${index}`}
                                                    onInput={(e) => setRowHandler(e.target.value, "code", row)}
                                                    defaultValue={row.code}
                                                    variant="outlined"
                                                    error={error.codeText.length > 0}
                                                    helperText={error.codeText}
                                                />
                                            ) : (
                                                row.code
                                            )}
                                        </TableCell>
                                        <TableCell id={`gt_TableCell_2_${index}`} align="center">
                                            {editable && editableRow === row.id ? (
                                                <TextField
                                                    id={`gt_TableCell_2_TextField_${index}`}
                                                    inputProps={{ maxLength: "50" }}
                                                    onInput={(e) => setRowHandler(e.target.value, "name", row)}
                                                    defaultValue={row.name}
                                                    variant="outlined"
                                                    error={error.nameText.length > 0}
                                                    helperText={error.nameText}
                                                />
                                            ) : (
                                                row.name
                                            )}
                                        </TableCell>
                                        <TableCell id={`gt_TableCell_3_${index}`} align="center">
                                            {row.breakdownRootCauseLocalizationName}
                                        </TableCell>
                                        <TableCell id={`gt_TableCell_4_${index}`} align="center">
                                            {editable && editableRow === row.id && editableRow === "" ? (
                                                <Autocomplete
                                                    id={`gt_TableCell_4_Autocomplete_${index}`}
                                                    defaultValue={row.plantCode}
                                                    onChange={(event, newValue) => {
                                                        newPlantID(newValue);
                                                    }}
                                                    options={plantList.map((option) => option.code)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            id={`gt_TableCell_4_TextField_${index}`}
                                                            {...params}
                                                            margin="normal"
                                                            variant="outlined"
                                                            error={error.plantCodeText.length > 0}
                                                            helperText={error.plantCodeText}
                                                        />
                                                    )}
                                                />
                                            ) : (
                                                row.plantCode
                                            )}
                                        </TableCell>
                                        <TableCell id={`gt_TableCell_5_${index}`} align="center">
                                            {" "}
                                            {editable && editableRow === row.id && editableRow === "" ? addPlantName : row.plantName}
                                        </TableCell>
                                        <TableButtons
                                            editable={editable}
                                            editableRow={editableRow}
                                            row={row}
                                            addDisabled={isButtonDisable}
                                            updateAddHandler={() => updateAddHandler(row)}
                                            disableEditHandler={() => disableEditHandler()}
                                            enableEditHandler={() => enableEditHandler(row)}
                                            deleteButtonHandler={() => deleteButtonHandler(row)}
                                            openDetailPage={() => openDetailPage(row.id)}
                                            detail={props.table === "Pool" ? true : false}
                                        />
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            id="gt_TablePagination"
                            rowsPerPageOptions={[20, 50, 100]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Grow>
            ) : null}
            <Modal title={t("Delete")} content={t("WillYouDoTransaction")} approved={() => deleteHandler(deletedRow)} isModalOpen={isModalOpen} toggle={toggleModal} />
            <LoadingBackdrop />
        </StyledTableDiv>
    );
}
